import React from 'react'

import RdnaIconHelper from '../../../assets/icons/IconHelper'
export default RdnaIconHelper

export * from '../../../assets/icons/IconHelper'
